import { appEnv } from '@/app/config/env';

import { Clarity } from './instance';

if (import.meta.env.PROD && appEnv.clarityId) {
  Clarity.init(appEnv.clarityId);
}
